var layoutScreen = {
    base: {
        minHeight: "100vh",
        font: "body",
        "--mobile-header-height": "2.5rem",
    },
};
var layoutMobileHeader = {
    base: {
        display: ["flex", "none"],
        width: "100%",
        alignItems: "center",
        height: "var(--mobile-header-height)",
    },
};
var layoutSidebar = {
    base: {
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        position: ["absolute", "fixed"],
        top: ["var(--mobile-header-height)", 0],
        height: ["auto", "100vh"],
        left: ["-100%", 0],
        zIndex: "layoutSidebar",
        "&[data-is-open=true]": {
            left: [0, 0],
            transition: "left ease-out",
            transitionDuration: 8,
        },
        transition: "left ease-in",
        transitionDuration: 8,
    },
};
var layoutBody = {
    base: {
        minHeight: "100vh",
        marginLeft: [0, "var(--layout-sidebar-width)"],
    },
};
var layoutHeader = {
    base: {
        boxShadow: 1,
        position: "sticky",
        top: 0,
        width: "100%",
        zIndex: "layoutHeader",
        bg: "white",
    },
};
var layoutContent = {
    base: {
        minHeight: "calc(100vh - var(--layout-header-height))",
    },
};

export { layoutBody, layoutContent, layoutHeader, layoutMobileHeader, layoutScreen, layoutSidebar };
//# sourceMappingURL=layout-screen.js.map
